import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Tooltip from '../../components/Tooltip';
import Modal from '../../components/Modal';
import Avatar from '../../components/Avatar';
import IconButton from '../../components/IconButton';
import UserModal from '../../components/UserModal';
import useResponsive from '../../utils/useResponsive';
import {
  MdAccountTree as AccountTreeOutlined,
  MdAllInclusive as AllInclusive,
  // MdAnnouncement as AnnouncementOutlined, // usado pelo item Informativos (oculto)
  MdBarChart as BarChart,
  MdBusiness as Business,
  // MdCake as Cake, // aniversário desativado
  MdChat as Chat,
  MdChatBubbleOutline as ChatBubbleOutline,
  MdChevronLeft as ChevronLeft,
  MdChevronRight as ChevronRight,
  MdCode as Code,
  MdContactPhone as ContactPhoneOutlined,
  MdDashboard as DashboardOutlined,
  MdDeviceHub as DeviceHubOutlined,
  MdEventAvailable as EventAvailable,
  MdExitToApp as ExitToApp,
  MdExpandLess as ExpandLess,
  MdExpandMore as ExpandMore,
  MdFlashOn as FlashOn,
  MdHistory as History,
  MdLocalAtm as LocalAtm,
  MdLocalOffer as LocalOffer,
  MdPersonOutline as PersonOutline,
  MdPhonelinkSetup as PhonelinkSetup,
  MdReceiptLong as ReceiptLong,
  MdSchedule as Schedule,
  MdSettings as Settings,
  MdShoppingCart as ShoppingCartOutlined,
  MdSyncAlt as SyncAlt,
  MdViewColumn as ViewColumn,
  MdWebhook as Webhook,
} from 'react-icons/md';
import { AuthContext } from '../../context/Auth/AuthContext';
import { ConnectionContext } from '../../context/Connection/ConnectionContext';
import ColorModeContext from '../themeContext';
import logoSidebarOpen from '../../assets/sidebar/logo-normal.png';
import logoSidebarOpenDark from '../../assets/sidebar/logo-normal-dark.png';
import logoSidebarClosed from '../../assets/sidebar/logo-small.png';

const allMenuItems = [
  { id: 'atendimento', title: 'Atendimento', subtitle: 'Conversas e tickets', icon: ChatBubbleOutline, route: '/tickets', profiles: ['admin', 'user'] },
  { id: 'pedidos', title: 'Pedidos', subtitle: 'Pedidos de todos os contatos', icon: ReceiptLong, route: '/orders', profiles: ['admin', 'user'] },
  { id: 'produtos', title: 'Produtos', subtitle: 'Catálogo de produtos', icon: ShoppingCartOutlined, route: '/products', profiles: ['admin', 'user'] },
  { id: 'contatos', title: 'Contatos', subtitle: 'Gerenciar contatos', icon: ContactPhoneOutlined, route: '/contacts', profiles: ['admin', 'user'] },
  { id: 'chat', title: 'Chat interno', subtitle: 'Comunicação da equipe', icon: Chat, route: '/chats', profiles: ['admin', 'user'] },
  { id: 'respostas', title: 'Respostas rápidas', subtitle: 'Mensagens rápidas', icon: FlashOn, route: '/quick-messages', profiles: ['admin'] },
  { id: 'kanban', title: 'Kanban', subtitle: 'Organização dos atendimentos', icon: ViewColumn, route: '/kanban', profiles: ['admin'] },
  { id: 'indicadores', title: 'Indicadores', subtitle: 'Dashboard e métricas', icon: DashboardOutlined, route: '/', profiles: ['admin', 'user'] },
  { id: 'agendamentos', title: 'Agendamentos', subtitle: 'Atendimentos agendados', icon: Schedule, route: '/schedules', profiles: ['admin'] },
  { id: 'tags', title: 'Tags', subtitle: 'Organizar contatos e tickets', icon: LocalOffer, route: '/tags', profiles: ['admin'] },
  {
    id: 'campanhas',
    title: 'Campanhas',
    subtitle: 'Campanhas e listas de contatos',
    icon: EventAvailable,
    profiles: ['admin'],
    children: [
      { id: 'campanhas-lista', title: 'Campanhas', subtitle: 'Listar campanhas', icon: EventAvailable, route: '/campaigns' },
      { id: 'listas-contatos', title: 'Listas de contatos', subtitle: 'Público das campanhas', icon: ContactPhoneOutlined, route: '/contact-lists' },
      { id: 'campanhas-config', title: 'Configurações', subtitle: 'Configurar campanhas', icon: Settings, route: '/campaigns-config' },
      { id: 'arquivos', title: 'Arquivos', subtitle: 'Arquivos das campanhas', icon: Code, route: '/files' },
    ],
  },
  {
    id: 'flowbuilder',
    title: 'Flowbuilder',
    subtitle: 'Automação de conversas',
    icon: Webhook,
    profiles: ['admin'],
    children: [
      { id: 'fluxo-campanha', title: 'Fluxo de campanha', subtitle: 'Automação de campanhas', icon: EventAvailable, route: '/phrase-lists' },
      { id: 'fluxo-conversa', title: 'Fluxo de conversa', subtitle: 'Automação do atendimento', icon: Webhook, route: '/flowbuilders' },
    ],
  },
  { id: 'relatorios', title: 'Relatórios', subtitle: 'Desempenho e indicadores', icon: BarChart, route: '/reports', profiles: ['admin'] },
  { id: 'administracao', type: 'section', title: 'Administração', profiles: ['admin'] },
  // Informativos oculto do menu por enquanto (rota /announcements continua acessível)
  // { id: 'informativos', title: 'Informativos', subtitle: 'Avisos para os usuários', icon: AnnouncementOutlined, route: '/announcements', profiles: ['admin'] },
  { id: 'api', title: 'API', subtitle: 'Integração por mensagens', icon: Code, route: '/messages-api', profiles: ['admin'] },
  { id: 'filas', title: 'Filas & Chatbot', subtitle: 'Filas e setores de atendimento', icon: AccountTreeOutlined, route: '/queues', profiles: ['admin'] },
  { id: 'talk-ai', title: 'Talk.Ai', subtitle: 'Prompts de inteligência artificial', icon: AllInclusive, route: '/prompts', profiles: ['admin'] },
  { id: 'usuarios', title: 'Usuários', subtitle: 'Gerenciar equipe e acessos', icon: ContactPhoneOutlined, route: '/users', profiles: ['admin'] },
  // Aniversário desativado por enquanto (não usado no momento)
  // { id: 'aniversario', title: 'Config. Aniversário', subtitle: 'Mensagens de aniversário', icon: Cake, route: '/birthday-settings', profiles: ['admin'] },
  { id: 'conexoes', title: 'Conexões', subtitle: 'Canais de atendimento', icon: SyncAlt, route: '/connections', profiles: ['admin'] },
  { id: 'integracoes', title: 'Integrações', subtitle: 'Integrações das filas', icon: DeviceHubOutlined, route: '/queue-integration', profiles: ['admin'] },
  { id: 'gerenciar-conexoes', title: 'Gerenciar conexões', subtitle: 'Todas as conexões', icon: PhonelinkSetup, route: '/allConnections', profiles: ['root'] },
  { id: 'empresas', title: 'Empresas', subtitle: 'Gerenciar empresas', icon: Business, route: '/companies', profiles: ['root'] },
  { id: 'financeiro', title: 'Financeiro', subtitle: 'Planos e cobranças', icon: LocalAtm, route: '/financeiro', profiles: ['root'] },
  { id: 'config', title: 'Configurações', subtitle: 'Conta, equipe e integrações', icon: Settings, route: '/settings', profiles: ['admin', 'root'] },
  { id: 'audit-logs', title: 'Logs de Auditoria', subtitle: 'Ações de todos os usuários', icon: History, route: '/audit-logs', profiles: ['root'] },
];

const MenuBadge = ({ count, className = '' }) => {
  if (!count) return null;
  return (
    <span
      className={`min-w-[16px] h-4 px-1 rounded-full flex items-center justify-center text-[10px] font-bold leading-none text-white bg-red-500 ${className}`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};

const Sidebar = ({ expanded, onToggle, mode = "push", profileUrl, pendingCount = 0 }) => {
  const isDesktop = useResponsive();
  const { colorMode } = useContext(ColorModeContext);
  const openLogo = colorMode?.mode === 'dark' ? logoSidebarOpenDark : logoSidebarOpen;
  const history = useHistory();
  const location = useLocation();
  const { user, handleLogout } = useContext(AuthContext);
  const { isOffline, offlineSince } = useContext(ConnectionContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [profileModalOpen, setProfileModalOpen] = useState(false);

  const userName =
    user?.name ||
    user?.username ||
    user?.email ||
    localStorage.getItem('username') ||
    localStorage.getItem('name') ||
    'Usuário';
  const profile = user?.profile || 'user';
  // "Meu perfil" vale para user, admin e root: edita só os dados do usuário logado
  const canEditOwnProfile = Boolean(user?.id);

  const openProfileModal = () => {
    setMenuOpen(false);
    setProfileModalOpen(true);
  };

  // Queda do backend aparece só aqui, discreta, no lugar do "Online"
  const offlineTime = offlineSince
    ? new Date(offlineSince).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    : '';
  const statusLabel = isOffline
    ? `Conexão perdida${offlineTime ? ` · ${offlineTime}` : ''}`
    : 'Online';
  const statusDotClass = isOffline ? 'bg-red-500' : 'bg-green-600';
  const menuItems = allMenuItems.filter(
    item => item.profiles.includes(profile) || (profile === 'root' && item.profiles.includes('admin'))
  );

  const handleNavClick = (item) => {
    setMenuOpen(false);
    if (item.route) history.push(item.route);
  };

  const routeIsActive = route => route === '/'
    ? location.pathname === '/'
    : location.pathname.toLowerCase().startsWith(route.toLowerCase());

  const isActive = item => item.children
    ? item.children.some(child => routeIsActive(child.route))
    : item.route && routeIsActive(item.route);

  const toggleSubmenu = id => {
    setOpenSubmenus(current => ({ ...current, [id]: !current[id] }));
  };

  const iconColumn = (
    <div className="w-16 flex-shrink-0 h-full flex flex-col items-center py-3 bg-farmazon-surface">
      <button
        onClick={onToggle}
        className="w-10 h-10 rounded-xl overflow-hidden mb-6 border-none cursor-pointer p-0 shadow-sm"
      >
        <img
          src={logoSidebarClosed}
          alt="logo"
          className="w-full h-full block object-contain p-1"
        />
      </button>

      <div className="flex-1 min-h-0 w-full overflow-y-auto overflow-x-visible pt-1.5 flex flex-col items-center gap-1">
        {menuItems.map(item => {
          if (item.type === 'section') return null;
          const active = isActive(item);
          const Icon = item.icon;
          return (
            <Tooltip key={item.id} title={item.title} placement="right" arrow>
              <button
                onClick={() => handleNavClick(item.children ? item.children[0] : item)}
                className={`relative z-0 focus:z-10 hover:z-10 w-11 h-11 rounded-xl flex items-center justify-center border-none cursor-pointer transition-colors duration-150 ${active ? 'z-10 bg-farmazon-green-soft text-green-600' : 'bg-transparent text-farmazon-text-muted hover:bg-farmazon-hover'}`}
              >
                <Icon className="!text-[18px]" />
                {active && (
                  <span className="absolute left-[-12px] top-1/2 -translate-y-1/2 w-[3px] h-[22px] rounded-sm bg-green-600" />
                )}
                {item.id === 'atendimento' && (
                  <MenuBadge count={pendingCount} className="absolute -top-1 -right-1 z-20" />
                )}
              </button>
            </Tooltip>
          );
        })}
      </div>

      <div className="mt-auto flex flex-col items-center">
        <Tooltip title={`${userName} · ${statusLabel}`} placement="right" arrow>
          <button className="rounded-full relative border-none cursor-pointer bg-none p-0 mb-2">
            <Avatar src={profileUrl} name={userName} className="!w-9 !h-9" />
            <span className={`absolute right-0 bottom-0 w-2.5 h-2.5 rounded-full border-2 border-farmazon-surface ${statusDotClass}`} />
          </button>
        </Tooltip>
        {canEditOwnProfile && (
          <Tooltip title="Meu perfil" placement="right" arrow>
            <button
              onClick={openProfileModal}
              className="w-9 h-9 rounded-xl flex items-center justify-center border-none cursor-pointer transition-colors duration-150 bg-transparent text-farmazon-text-muted hover:bg-farmazon-hover"
            >
              <PersonOutline size={18} />
            </button>
          </Tooltip>
        )}
        <Tooltip title="Sair do sistema" placement="right" arrow>
          <button
            onClick={handleLogout}
            className="w-9 h-9 rounded-xl flex items-center justify-center border-none cursor-pointer transition-colors duration-150 text-farmazon-text-muted hover:bg-farmazon-hover"
          >
            <ExitToApp size={18} />
          </button>
        </Tooltip>
      </div>
    </div>
  );

  const renderExpandedPanel = ({ withClose } = {}) => {
    const handleClose = withClose ? () => setMenuOpen(false) : onToggle;
    return (
      <div className="h-full w-full flex flex-col min-w-0 bg-farmazon-surface border-r border-farmazon-border">
        <div className="flex items-center gap-3 px-5 pt-[10px] pb-[6px] flex-shrink-0">
          <img src={openLogo} alt="FarmazOn" className="h-[52px] block" />
          <div className="flex-1" />
          {withClose && (
            <IconButton size="small" onClick={handleClose} className="text-slate-500">
              <ChevronRight size={18} />
            </IconButton>
          )}
          {!withClose && (
            <IconButton size="small" onClick={handleClose} className="text-slate-500">
              <ChevronLeft size={18} />
            </IconButton>
          )}
        </div>

        {user?.company?.name && (
          <div className="flex items-center gap-2 px-5 pb-[10px] flex-shrink-0 min-w-0">
            <span className="flex items-center justify-center w-7 h-7 rounded-full bg-slate-100 flex-shrink-0">
              <Business size={16} className="text-slate-600" />
            </span>
            <span
              className="truncate text-[13px] font-semibold text-slate-600"
              title={user.company.name}
            >
              {user.company.name}
            </span>
          </div>
        )}

        <div className="flex-1 overflow-y-auto min-h-0 px-3 py-1">
          {menuItems.map(item => {
            if (item.type === 'section') {
              return (
                <div key={item.id} className="mx-[-12px] my-2 border-y border-solid border-x-0 border-farmazon-border px-6 py-2 text-xs font-medium text-farmazon-text-muted">
                  {item.title}
                </div>
              );
            }

            const active = isActive(item);
            const Icon = item.icon;
            const submenuOpen = openSubmenus[item.id] || active;
            return (
              <React.Fragment key={item.id}>
                <button
                  onClick={() => item.children ? toggleSubmenu(item.id) : handleNavClick(item)}
                  className={`w-full flex items-center gap-3 p-2.5 rounded-xl border-none cursor-pointer text-left mb-0.5 ${active ? 'bg-farmazon-green-soft' : 'bg-transparent hover:bg-farmazon-hover'}`}
                >
                  <div
                    className={`relative z-0 grid place-items-center w-11 h-11 rounded-xl flex-shrink-0 ${active ? 'z-10 bg-farmazon-green-bubble text-green-600' : 'bg-farmazon-surface-muted text-farmazon-text'}`}
                  >
                    <Icon className="!text-[18px]" />
                    {item.id === 'atendimento' && (
                      <MenuBadge count={pendingCount} className="absolute -top-1 -right-1 z-20" />
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className={`text-[15px] font-bold leading-tight ${active ? 'text-green-600' : 'text-farmazon-text'}`}>
                      {item.title}
                    </div>
                    <div className="text-xs truncate text-farmazon-text-muted">
                      {item.subtitle}
                    </div>
                  </div>
                  {item.children && (submenuOpen ? <ExpandLess size={18} className="text-farmazon-text-muted" /> : <ExpandMore size={18} className="text-farmazon-text-muted" />)}
                </button>

                {item.children && submenuOpen && (
                  <div className="ml-[22px] border-l border-solid border-y-0 border-r-0 border-farmazon-border pl-3 mb-1">
                    {item.children.map(child => {
                      const childActive = isActive(child);
                      const ChildIcon = child.icon;
                      return (
                        <button
                          key={child.id}
                          onClick={() => handleNavClick(child)}
                          className={`w-full flex items-center gap-2 rounded-lg border-none px-2 py-2 text-left cursor-pointer ${childActive ? 'bg-farmazon-green-soft text-green-600' : 'bg-transparent text-farmazon-text hover:bg-farmazon-hover'}`}
                        >
                          <ChildIcon className="!text-[18px] flex-shrink-0" />
                          <span className="text-[13px] font-semibold truncate">{child.title}</span>
                        </button>
                      );
                    })}
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>

        <div className="flex-shrink-0 px-3 pt-1">
          <div className="flex items-center gap-2.5 p-2 rounded-xl cursor-pointer mb-1.5">
            <div className="relative flex-shrink-0">
              <Avatar src={profileUrl} name={userName} className="!w-10 !h-10" />
              <span className={`absolute right-0 bottom-0 w-[11px] h-[11px] rounded-full border-2 border-farmazon-surface ${statusDotClass}`} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-bold leading-tight truncate text-farmazon-text">{userName}</div>
              <div className={`text-xs truncate ${isOffline ? 'text-farmazon-text-muted' : 'text-green-600'}`}>{statusLabel}</div>
            </div>
          </div>
          {canEditOwnProfile && (
            <button
              onClick={openProfileModal}
              className="w-full flex items-center justify-center gap-1 py-[10px] rounded-xl font-bold text-[13.5px] cursor-pointer mt-1.5 border border-solid border-farmazon-border text-farmazon-text bg-farmazon-surface shadow-none outline-none hover:bg-farmazon-hover"
            >
              <PersonOutline className="!text-[18px]" /> Meu perfil
            </button>
          )}
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-1 py-[10px] rounded-xl font-bold text-[13.5px] cursor-pointer mt-1.5 mb-1.5 border border-solid border-farmazon-border text-farmazon-text bg-farmazon-surface shadow-none outline-none hover:bg-farmazon-hover"
          >
            <ExitToApp className="!text-[18px]" /> Sair do sistema
          </button>
        </div>

        <div className="flex-shrink-0 px-5 py-[7px] bg-farmazon-bg">
          {/* <div className="flex items-center gap-1">
            <span className="flex text-green-600 text-lg">✦</span>
            <span className="text-[13px] font-bold text-green-600">Novidades</span>
            <span className="min-w-[18px] h-[18px] px-[5px] rounded-full flex items-center justify-center text-[11px] font-extrabold text-white bg-green-600">2</span>
          </div> */}
          <div className="text-[11.5px] mt-1 text-farmazon-text-faint">v4.0.0</div>
        </div>
      </div>
    );
  };

  return (
    <>
      {isDesktop && (
        <>
          <div
            className={`h-full flex overflow-hidden transition-all duration-300 ease-in-out bg-farmazon-surface flex-shrink-0 ${mode === 'push' && expanded ? 'w-[270px]' : 'w-16'}`}
          >
            {mode === 'push' && expanded ? renderExpandedPanel() : iconColumn}
          </div>

          {mode === 'overlay' && expanded && (
            <>
              <div className="fixed inset-0 z-[1255]" onClick={onToggle} />
              <div className="fixed top-0 bottom-0 left-0 z-[1260] w-[min(270px,86vw)] shadow-xl">
                {renderExpandedPanel()}
              </div>
            </>
          )}
        </>
      )}

      <Modal
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        className="justify-start bg-black/50"
      >
        <div className="h-full w-[min(320px,86vw)] shadow-xl">
          {renderExpandedPanel({ withClose: true })}
        </div>
      </Modal>

      {/* monta só quando aberto: o UserModal carrega conexões e escuta eventos delas */}
      {canEditOwnProfile && profileModalOpen && (
        <UserModal
          open={profileModalOpen}
          onClose={() => setProfileModalOpen(false)}
          userId={user.id}
          selfEdit
        />
      )}
    </>
  );
};

export default Sidebar;
